var sandbox = {
    activityTab: {
        activity: 'Activity',
        date: 'Date',
        description: 'Description',
        amount: 'Amount'
    },
    promotions: {
        noPromotions: 'You have no promotions at this time'
    },
    accountInfo: {
        accountEndingIn: 'Account ending in {{accountLast4}}',
        accountServices: 'Account Services',
        activity: 'Activity',
        availableToSpend: 'Available to spend',
        currentBalance: 'Current Balance',
        dueDate: 'Payment Due Date',
        makeAPayment: 'Make a Payment',
        totalMinimumPayment: 'Total Minimum Payment'
    },
    accountDashboard: {
        autoPay: 'Autopay',
        available: 'Available to spend',
        details: 'Details',
        mayNotReflect: 'May not reflect recent transactions',
        more: 'More',
        off: 'off',
        statements: 'Statements'
    },
    activitySidebar: {
        promotions: 'Promotions'
    },
    alerts: {
        balanceAlerts: 'Balance Alerts',
        balanceAlertsAvailableCredit: 'Available credit is within $_____ of credit limit',
        balanceAlertsExceedsCreditLimit: 'Balance exceeds credit limit',
        balanceAlertsExceedsValue: 'Balance exceeds $_____',
        buttonText: 'Update phone or email',
        contactInfo: 'Contact Information',
        contactMessage: 'Receive email and text alerts for important actions on your account. Alerts will be sent to the email address and phone number in your profile.',
        emailAddressContent: 'M***********A@S*F.COM',
        emailAddressTitle: 'Email Address',
        paymentAlerts: 'Payment Alerts',
        paymentAlertsAutoPay: 'Payment or Autopay is due in {{paymentNumberOfDays}} days',
        paymentAlertsPromoPurchase: 'Promotional purchase will expire in _____ days',
        phoneNumberContent: 'No number on file',
        phoneNumberTitle: 'Phone Number',
        securityInformation: 'Security Alerts',
        securityInformationPayments: 'Payments',
        securityInformationPaymentsDescription: 'Autopay, payment scheduled, payment posted',
        securityInformationProfileChange: 'Profile Change',
        securityInformationProfileChangeDescription: 'Your personal information (address, email, or phone) has been changed',
        securityInformationTagline: 'For your security, you will always receive an email for the following alerts and they cannot be turned off.',
        spendingAlerts: 'Spending Alerts',
        spendingAlertsApproved: 'Approved transactions',
        spendingAlertsCredit: 'Credit or refund is posted',
        spendingAlertsDeclined: 'Declined transactions',
        switchOff: 'OFF',
        switchOn: 'ON',
        title: 'Alerts Management'
    },
    personalGreeting: {
        morning: 'Good Morning',
        afternoon: 'Good Afternoon',
        evening: 'Good Evening'
    },
    services: {
        accountServices: 'Account Services',
        creditLimitIncrease: 'Credit limit increase',
        changePaymentDate: 'Change payment due date',
        activateCard: 'Activate a card',
        freezeCard: 'Freeze card',
        replaceYourCard: 'Replace your card',
        reportLost: 'Report lost or stolen card',
        manageTravelPlans: 'Manage travel notifications',
        createPIN: 'Create/change PIN',
        cardActions: 'Card Actions',
        security: 'Security',
        accountActions: 'Account Actions',
        manageCardHolders: 'Manage cardholders'
    }
};
export default sandbox;
//# sourceMappingURL=sandbox.js.map